<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <v-btn class="mx-2" icon text small :to="{ name: 'equipamento-list' }">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span v-if="tituloNovo">Novo equipamento</span>
              <span v-else>Alterar equipamento: {{codigo}} - {{descricao}}</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-tabs v-model="tabs" grow>
            <v-tab v-if="perms.includes('equipamento.editar_dados')">
              <v-icon left color="error" v-if="$v.$invalid" class="mdi mdi-alert-circle"></v-icon>
              <span>Geral</span>
            </v-tab>
            <v-tab>Documentos</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item v-if="perms.includes('equipamento.editar_dados')">
              <v-card-text>
                <v-text-field
                  v-model="codigo"
                  :error-messages="codigoErrors"
                  :counter="10"
                  label="Código"
                  required
                  @input="$v.codigo.$touch()"
                  @blur="$v.codigo.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="descricao"
                  :error-messages="descricaoErrors"
                  :counter="50"
                  label="Descrição"
                  required
                  @input="$v.descricao.$touch()"
                  @blur="$v.descricao.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="capacidade"
                  :error-messages="capacidadeErrors"
                  :counter="10"
                  label="Capacidade"
                  @input="$v.capacidade.$touch()"
                  @blur="$v.capacidade.$touch()"
                ></v-text-field>
                <v-switch v-model="ativo" label="Ativo" persistent-hint />
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <lista-documentos
                url-base="equipamento"
                :id-proprietario="id"
                v-model="documentos"
                alterar
              />
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading">Salvar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength, decimal } from "vuelidate/lib/validators";
import ListaDocumentos from "../components/documentos/ListaDocumentos";

export default {
  components: { ListaDocumentos },
  mixins: [validationMixin],

  validations: {
    codigo: { required, maxLength: maxLength(10) },
    descricao: { required, maxLength: maxLength(50) },
    capacidade: { maxLength: maxLength(10), decimal },
    ativo: { required }
  },

  data() {
    return {
      id: "",
      codigo: "",
      descricao: "",
      capacidade: "",
      ativo: true,
      tituloNovo: true,

      loading: false,
      ativos: [
        { codigo: "true", descricao: "Sim" },
        { codigo: "false", descricao: "Não" }
      ],
      search: null,
      select: null,
      tabs: null,
      documentos: []
    };
  },

  computed: {
    ...mapState({
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
    codigoErrors() {
      const errors = [];
      if (!this.$v.codigo.$dirty) return errors;
      !this.$v.codigo.required && errors.push("Código é Obrigatório.");
      !this.$v.codigo.maxLength && errors.push("Somente 10 caracteres.");

      return errors;
    },
    descricaoErrors() {
      const errors = [];
      if (!this.$v.descricao.$dirty) return errors;
      !this.$v.descricao.required && errors.push("Descrição é Obrigatório.");
      !this.$v.descricao.maxLength && errors.push("Somente 50 caracteres.");
      return errors;
    },
    capacidadeErrors() {
      const errors = [];
      if (!this.$v.capacidade.$dirty) return errors;
      !this.$v.capacidade.maxLength && errors.push("Somente 10 caracteres.");
      !this.$v.capacidade.decimal && errors.push("Somente número");
      return errors;
    },
    ativoErrors() {
      const errors = [];
      if (!this.$v.ativo.$dirty) return errors;
      !this.$v.ativo.required && errors.push("Campo é Obrigatório.");
      return errors;
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    }
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        try {
          const equipamento = await this.$store.dispatch("equipamento/gravar", {
            id: this.id,
            codigo: this.codigo,
            descricao: this.descricao,
            capacidade:
              this.capacidade == "" ? null : parseFloat(this.capacidade),
            ativo: this.ativo
          });
          if (this.documentos.length > 0) {
            await this.$store.dispatch("documento/gravar", {
              urlBase: "equipamento",
              IDProprietario: equipamento.id,
              documentos: this.documentos
            });
          }
          this.$router.replace({ path: "lista", name: "equipamento-list" });
        } catch (err) {
          console.log(err);
          this.loading = false;
          this.$store.commit("ui/setSnackbar", {
            text: "Não foi possível salvar o equipamento"
          });
        }
      }
    },
    querySelections(v) {
      this.loading = true;
      v;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de equipamentos"
    });

    this.id = "";
    this.loading = true;
    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      try {
        var response = await this.$store.dispatch(
          "equipamento/carregarEquipamento",
          id
        );
        this.codigo = response.data.codigo;
        this.descricao = response.data.descricao;
        this.capacidade = response.data.capacidade;
        this.ativo = response.data.ativo;
      } catch (err) {
        //deu pau
      }
    }
    this.loading = false;
  }
};
</script>
